var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('polygon',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"3","points":"11.98 15.44 18.45 19.38 18.45 3.53 5.54 3.53 5.54 19.34"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }